const normalizeKey = (value = '') => String(value || '').trim().toLowerCase();

export const getLoggedInUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem('user_token_ra') || '{}');
  } catch {
    return {};
  }
};

export const resolvePermissionKey = (moduleNames = [], accessRole = {}) => {
  const normalizedModuleNames = (Array.isArray(moduleNames) ? moduleNames : [moduleNames])
    .map(normalizeKey)
    .filter(Boolean);

  const availableKeys = Object.keys(accessRole || {});

  const matchingKey = normalizedModuleNames
    .map((moduleName) => availableKeys.find((key) => normalizeKey(key) === moduleName))
    .find(Boolean);
  return matchingKey || '';
};

export const getModulePermissions = (moduleNames = [], accessRole = {}) => {
  const resolvedKey = resolvePermissionKey(moduleNames, accessRole);
  return resolvedKey ? accessRole?.[resolvedKey] || {} : {};
};

export const hasModulePermission = (moduleNames = [], actionKey = 'View', accessRole = {}, defaultWhenUnset = true) => {
  const normalizedModuleNames = new Set(
    (Array.isArray(moduleNames) ? moduleNames : [moduleNames])
      .map(normalizeKey)
      .filter(Boolean)
  );
  const matchingPermissions = Object.entries(accessRole || {})
    .filter(([key]) => normalizedModuleNames.has(normalizeKey(key)))
    .map(([, permissions]) => permissions?.[actionKey])
    .filter((value) => typeof value === 'boolean');

  if (matchingPermissions.some((value) => value === true)) {
    return true;
  }

  if (matchingPermissions.length > 0) {
    return false;
  }

  return defaultWhenUnset;
};
